export default __webpack_public_path__ + "a4fd1b4619443325d585cdeb442d133f.svg";